import { CourseCreateStepEnum } from '../../../shared/models/enums/course-create-step.enum';
import { TabStep } from '../../../shared/models/interfaces/tab-step.interface';

export function getCourseCreateTabSteps(
  canAccessModules: boolean,
  canAccessContent: boolean,
  canAccessSummary: boolean,
): TabStep[] {
  return [
    { id: CourseCreateStepEnum.ABOUT, label: 'Sobre' },
    { id: CourseCreateStepEnum.MODULES, label: 'Módulos', disabled: !canAccessModules },
    { id: CourseCreateStepEnum.CONTENT, label: 'Conteúdo', disabled: !canAccessContent },
    { id: CourseCreateStepEnum.SUMMARY, label: 'Resumo', disabled: !canAccessSummary },
  ];
}

export enum CourseConclusionTypesEnum {
  DRAFT = 'draft',
  UPDATED = 'updated',
  PUBLISHED = 'published',
  CREATED = 'created',
}

export interface CourseConclusionContent {
  title: string;
  subtitle: string;
  iconPath: string;
}

export const COURSE_CONCLUSION_SUBTITLE = 'Você pode visualizar ou editar através da lista de cursos';
export const COURSE_CONCLUSION_ICON_PATH = 'assets/icons/check.svg';

export const COURSE_CONCLUSION_CONTENT: Record<CourseConclusionTypesEnum, CourseConclusionContent> = {
  [CourseConclusionTypesEnum.DRAFT]: {
    title: 'Curso salvo em rascunhos!',
    subtitle: COURSE_CONCLUSION_SUBTITLE,
    iconPath: 'assets/icons/draft.svg',
  },
  [CourseConclusionTypesEnum.UPDATED]: {
    title: 'Curso atualizado com sucesso!',
    subtitle: COURSE_CONCLUSION_SUBTITLE,
    iconPath: COURSE_CONCLUSION_ICON_PATH,
  },
  [CourseConclusionTypesEnum.PUBLISHED]: {
    title: 'Curso criado e publicado com sucesso!',
    subtitle: COURSE_CONCLUSION_SUBTITLE,
    iconPath: COURSE_CONCLUSION_ICON_PATH,
  },
  [CourseConclusionTypesEnum.CREATED]: {
    title: 'Curso criado com sucesso!',
    subtitle: COURSE_CONCLUSION_SUBTITLE,
    iconPath: COURSE_CONCLUSION_ICON_PATH,
  },
};
